// extracted by mini-css-extract-plugin
export var changeIcon = "_5f-4";
export var container = "_5f-0";
export var divider = "_5f-7";
export var externalLinkIcon = "_5f-1";
export var green = "_5f-5";
export var helpCircleIcon = "_5f-3";
export var iconButton = "_5f-2";
export var red = "_5f-6";